import React from "react";
import Typography, { TypographyProps } from "@material-ui/core/Typography";

type Props = Partial<TypographyProps>;

export function Label({ children, ...props }: Props) {
  return (
    <Typography component={"span" as any} {...props}>
      {children}
    </Typography>
  );
}

Label.defaultProps = {
  color: "inherit"
};
